import { observable, action, reaction } from "mobx";
import { message } from "antd";
import agent from "../agent";

class CommonStore {
  @observable appName = "robomaster-registration";
  @observable token = window.localStorage.getItem("jwt");
  @observable appLoaded = false;
  @observable mask = false;
  @observable trackReport = undefined;
  @observable gTag = undefined;
  @observable pca = undefined;

  constructor() {
    reaction(
      () => this.token,
      token => {
        if (token) {
          window.localStorage.setItem("jwt", token);
        } else {
          window.localStorage.removeItem("jwt");
        }
      }
    );
  }

  @action getPca() {
    return agent.Common.getPca()
      .then(res => {
        if (res && res.body) {
          this.pca = res.body;
          return res.body;
        }
        message.error("获取地址信息失败，请刷新页面重试。");
        return Promise.reject("获取地址信息失败。");
      })
      .catch(err => {
        message.error("获取地址信息失败，请刷新页面重试。");
        console.error(err);
        return Promise.reject(err);
      });
  }

  @action setToken(token) {
    this.token = token;
  }

  @action setAppLoaded() {
    this.appLoaded = true;
  }

  @action showMask() {
    this.mask = true;
  }

  @action closeMask() {
    this.mask = false;
  }

  @action setTrackReport(track) {
    this.trackReport = track;
  }

  @action setGTag(gTag) {
    this.gTag = gTag;
  }
}

export default new CommonStore();



// WEBPACK FOOTER //
// ./src/stores/commonStore.js